import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RestResponse } from '../../models/restResponse.mode';
import { Family, SaveFamilyPayload } from '../../models/family.model';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {
  private readonly baseUrl = `${environment.base_url}/families`;

  constructor(private http: HttpClient) {}

  getAll(
    description: string,
    active: boolean | null,
    page: number,
    paginate = true
  ): Observable<RestResponse<Family[]>> {
    const d = encodeURIComponent(description ?? '');
    return this.http.get<RestResponse<Family[]>>(
      `${this.baseUrl}/list?description=${d}&active=${active}&page=${page}&paginate=${paginate}`
    );
  }

  getById(id: number): Observable<RestResponse<Family>> {
    return this.http.get<RestResponse<Family>>(`${this.baseUrl}/find/${id}`);
  }

  create(payload: SaveFamilyPayload): Observable<RestResponse<{ id: number }>> {
    return this.http.post<RestResponse<{ id: number }>>(`${this.baseUrl}/save`, payload);
  }

  update(id: number, payload: SaveFamilyPayload): Observable<RestResponse<unknown>> {
    return this.http.put<RestResponse<unknown>>(`${this.baseUrl}/update/${id}`, payload);
  }

  delete(id: number): Observable<RestResponse<unknown>> {
    return this.http.delete<RestResponse<unknown>>(`${this.baseUrl}/delete/${id}`);
  }
}
